import { RootState } from 'redux/store';
import useToggle from 'hooks/useToggle';
import { useEffect, useState, useRef } from 'react';
import { Title, FormInput, Spinner, Modal } from 'components';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { getOwners, updateField, cleanOwnerDetails, getOwnerById, createOwner, UpdateOwner, updateOwnerField } from 'redux/slices/Owners';
import { Owner } from 'models/dbModels/owners/Owner';

export function NewOwner() {
	const form = useRef(null);
	const {ownerId} = useParams();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [isValidated, setValidated] = useToggle();
	const owners = useAppSelector((state: RootState) => state.owners);
	const [isNewOwner, setIsNewOwner] = useState<boolean>(false);
	const [showPrompt, setShowPrompt] = useState<boolean>(false);

	useEffect(() => {
		if (ownerId) {
			const id = parseInt(ownerId);
			dispatch(getOwnerById(id));
			setIsNewOwner(false);
		} else {
			dispatch(cleanOwnerDetails());
			setIsNewOwner(true);
		}
	}, [ownerId]);

	function handleSubmit() {
		dispatch(updateField({ key: 'loading', value: true }));
		// @ts-ignore
		if (form.current.checkValidity() === true) {
			const owner: Owner = owners.owner

			if (isNewOwner) {
				dispatch(createOwner(owner)).then((res) => {			
					dispatch(getOwners({}));
					setTimeout(() => {
						navigate('/support/owners');
					}, 1000);
				});
			} else {
				dispatch(UpdateOwner(owner)).then((res) => {			
					dispatch(getOwners({}));
					setTimeout(() => {
						navigate('/support/owners');
					}, 1000);
				});
			}

		} else {
			dispatch(updateField({ key: 'loading', value: false }));	
		}
		setValidated();
	}

	return (
		<>
			<Title pageTitle={isNewOwner ? "New Owner" : "Update Owner"} parent="Admin" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<Form validated={isValidated} ref={form}>
									<Row>
										<h4 className="mt-2">Owner Details</h4>
										<p className="text-muted">Fill the form below create a new owner.</p>
										<Col md={6}>
											<FormInput
												label="Name"
												type="text"
												name="account-given-name"
												placeholder="Enter name"
												containerClass={'mb-3'}
												required
												value={owners.owner.name}
												onChange={(e) => dispatch(updateOwnerField({ key: "name", value: e.target.value }))}
											/>
										</Col>
										<Col md={6}>
											<FormInput
												label="Comments"
												type="text"
												name="account-comment"
												placeholder="Enter comments"
												containerClass={'mb-3'}
												value={owners.owner.comments || ""}
												onChange={(e) => dispatch(updateOwnerField({ key: "comments", value: e.target.value }))}
											/>
										</Col>
									</Row>
									<Row className='mt-3'>
										<Col sm={6}>
											<Link to="/support/owners" className="btn text-muted d-none d-sm-inline-block btn-link fw-semibold">
												<i className="mdi mdi-arrow-left"></i> Back to All Owners {' '}
											</Link>
										</Col>
										<Col sm={6} className="d-flex flex-row-reverse">
											<Button variant="primary" className="btn cta-button" disabled={owners.loading} onClick={() => setShowPrompt(true)}>
												{owners.loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
												{owners.loading ? <>Saving...</> : <>Save</>}
											</Button>
										</Col>
									</Row>
								</Form>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			<Modal
				title="Confirm - Save Owner"
				show={showPrompt}
				buttonType="primary"
				disableButtons={false}
				buttonText={"Accept"}
				handleClose={() => setShowPrompt(false)}
				handleSubmit={() => {
					handleSubmit();
					setShowPrompt(false);
				}}
				description={
					<>
						<p>Confirm Details</p>
						<p>Are you sure you want to continue?</p>
					</>
				}
			/>
		</>
	);
}